import { Navigate, generatePath } from "react-router";

import { PATHS } from "@/routes/paths";

import * as Repository from "@/components/features/invoice-system-settings/model/repository";

import { InvoiceSystemSettingsPresenter } from "./presenter";

type Props = {
	hotelID: string;
};

export const InvoiceSystemSettingsContainer = ({ hotelID }: Props) => {
	const { data } = Repository.Query.useInvoiceSystemSettingsQuery(hotelID);

	if (!data) {
		return <Navigate to={generatePath(PATHS.HOTEL.TOP, { hotelID })} />;
	}

	return <InvoiceSystemSettingsPresenter data={data} />;
};
